"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletableLayoutRenderer = deletableLayoutRenderer;
const React = __importStar(require("react"));
const Contexts = __importStar(require("../contexts"));
const group_with_delete_button_renderer_1 = require("./group-with-delete-button-renderer");
const genesys_properties_selector_helpers_1 = require("../genesys-properties-selector-helpers");
function deletableLayoutRenderer(props) {
    const selectorInfoMap = (0, genesys_properties_selector_helpers_1.createSelectorInfoMap)(props.selectors);
    return (React.createElement(Contexts.propertiesSelectorContext.Consumer, null, ({ activatedQuantitySelectors, conversionParametersMap, filterPrettyPrint, layoutRendererExtraProps, onQuantityChange, valueSources, translatePropertyValue }) => {
        if (layoutRendererExtraProps.sections.length === 0) {
            return React.createElement("div", null);
        }
        const groups = layoutRendererExtraProps.sections[0].groups.map(group => (React.createElement(group_with_delete_button_renderer_1.GroupWithDeleteButtonRenderer, { key: `${layoutRendererExtraProps.uniqueId}-${group.key}`, filterPrettyPrint: filterPrettyPrint, renderGroup: group, fieldGroup: layoutRendererExtraProps.fieldGroup, hidePropertyNames: layoutRendererExtraProps.hidePropertyNames, onDelete: layoutRendererExtraProps.onDelete, uniqueId: layoutRendererExtraProps.uniqueId, valueSourcesDict: valueSources || {}, selectorInfoMap: selectorInfoMap, activatedQuantitySelectors: activatedQuantitySelectors, onQuantityChange: onQuantityChange, conversionParametersMap: conversionParametersMap, translatePropertyValue: translatePropertyValue, showDelete: layoutRendererExtraProps.showDelete })));
        return React.createElement("div", null, groups);
    }));
}
//# sourceMappingURL=operating-cases-layout-renderer.js.map